import type { GamificationActionTargets } from '../types/gamificationActions';
import { AppRoutes } from '@/i18n/constants';
import { GmRewardActionsEnum } from './gamificationRewardActions';

export const GAMIFICATION_ACTION_TARGETS = {
  [GmRewardActionsEnum.LEVEL_UP_CARD]: {
    kind: 'modal',
    modalName: 'gm-card-level-up',
    mobileHref: AppRoutes.gamificationLevelUp,
  },
  [GmRewardActionsEnum.STATUS_UP_CARD]: {
    kind: 'modal',
    modalName: 'gm-card-statuses',
    mobileHref: AppRoutes.gamificationStatusUp,
  },
  [GmRewardActionsEnum.GM_REWARD_REDEEM_INSTRUCTION]: {
    surfaceTargets: {
      'rewards-grid': { kind: 'link', href: AppRoutes.gamificationAllStages },
      'statuses': { kind: 'modal', modalName: 'gm-reward-redeem-instruction' },
    },
  },
  [GmRewardActionsEnum.OPEN_REFERRAL_PAGE]: {
    kind: 'link',
    href: AppRoutes.referral,
  },
  [GmRewardActionsEnum.FREE_SPINS]: {
    kind: 'link',
    href: AppRoutes.gamificationFreeSpins,
  },
} as const satisfies GamificationActionTargets;
